import i18nConfig from "~/config/i18n.json"
import { objectKeys } from "~/utils/object-keys"

export function getAllLocales() {
  return objectKeys(i18nConfig)
}
